export default __webpack_public_path__ + "static/media/sendMessageArrowIcon.1ee73c46.svg";